import { render, staticRenderFns } from "./MediaReviewActions.vue?vue&type=template&id=8d51884a&scoped=true&"
import script from "./MediaReviewActions.vue?vue&type=script&lang=js&"
export * from "./MediaReviewActions.vue?vue&type=script&lang=js&"
import style0 from "./MediaReviewActions.vue?vue&type=style&index=0&id=8d51884a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d51884a",
  null
  
)

export default component.exports